import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Tag from 'shopper/components/Tag/V2';

import useBlackFridayMissions from 'hooks/useBlackFridayMissions';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';
import { shareTo } from 'lib/share';
import { sendSupixEvent } from 'lib/supix';

import BLACK_FRIDAY from 'constants/blackFriday';
import SOCIAL_MEDIA from 'constants/socialMedia';

const SAVING_GAME_TABS = [
  {
    title: BLACK_FRIDAY.MY_BF_PAGE.SAVING_GAME_TAB,
    gaEventAction: 'my_bf_game_tab',
  },
  {
    title: BLACK_FRIDAY.MY_BF_PAGE.OFFERS_TAB,
    gaEventAction: 'offers_game_tab',
  },
  {
    title: BLACK_FRIDAY.MY_BF_PAGE.COUPONS_TAB,
    gaEventAction: 'coupons_game_tab',
  },
];

const SavingGameTimelineTabs = ({
  activeTab,
  setActiveTab,
  gaEventCategory,
}) => {
  const { checkpoints } = useBlackFridayMissions();

  const lastCheckedCheckpoint = checkpoints
    .filter((checkpoint) => checkpoint.checked)
    .at(-1);

  const onShareWhatsapp = () => {
    sendSupixEvent('/car', { category: 100010400 });

    sendEvent({
      action: 'send_invitation',
      category: gaEventCategory,
    });

    const message = lastCheckedCheckpoint
      ? `Estou no ${lastCheckedCheckpoint.label} no jogo da economia, venha participar também!`
      : `Venha participar do Jogo da Economia e economizar na Black Friday com o Promobit!`;

    shareTo({
      formatShareTextFn: () => message,
      url: `${window.location.origin}/minha-black-friday/jogo-da-economia/`,
      socialMedia: SOCIAL_MEDIA.WHATSAPP.TITLE,
      utmMedium: 'share',
      utmCampaign: 'minhabf',
    });
  };

  return (
    <div className="flex w-full flex-col items-end gap-y-5 md:justify-between lg:flex-row lg:gap-y-0">
      <div className="mt-4 flex w-full flex-row gap-x-2 self-start md:w-unset lg:mt-0 lg:gap-x-4">
        {SAVING_GAME_TABS.map(({ title, gaEventAction }) => {
          const isActive = activeTab === title;

          return (
            <Tag
              key={title}
              as="a"
              className="flex items-center rounded-5 py-2"
              filled={isActive}
              size="size2"
              type={isActive ? 'primary' : 'neutral'}
              bold
              clickable
              onClick={() => {
                setActiveTab(title);
                sendEvent({
                  action: gaEventAction,
                  category: BLACK_FRIDAY.MY_BF_PAGE.GA_EVENT_CATEGORY,
                });
              }}
            >
              {title}
            </Tag>
          );
        })}
      </div>
      <Button
        className={twMerge(
          'lg:flex',
          activeTab !== BLACK_FRIDAY.MY_BF_PAGE.SAVING_GAME_TAB && 'hidden'
        )}
        iconRight={<Icon name="share" />}
        size="size4"
        onClick={onShareWhatsapp}
      >
        <span className="block lg:hidden">{placeholder('actions.share')}</span>
        <span className="hidden lg:block">
          {placeholder('actions.shareMyProgess')}
        </span>
      </Button>
    </div>
  );
};

SavingGameTimelineTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
};

export default SavingGameTimelineTabs;
